import React from 'react';
import classNames from 'classnames';
import Tooltip from '../tooltip';
export default function () {
  var _this = this;

  var _this$props = this.props,
      topHint = _this$props.topHint,
      leftHint = _this$props.leftHint,
      rightHint = _this$props.rightHint,
      bottomHint = _this$props.bottomHint;
  return /*#__PURE__*/React.createElement("div", {
    "data-aid": this.props.automationId,
    "data-hook": this.props.dataHook,
    className: classNames(this.props.getClassName('control-docking-panel-outer'), {
      'is-disabled': this.props.disabled
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "docking-panel-inner"
  }, /*#__PURE__*/React.createElement("div", {
    "data-direction": "top",
    className: 'docking-direction top ' + this._getDockingState('TOP')
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: topHint,
    disabled: !topHint,
    isHint: true,
    alignment: 'TOP'
  }, /*#__PURE__*/React.createElement("div", {
    className: "docking-point",
    onClick: function onClick() {
      return _this._updateDockingState('TOP');
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "docking-line"
  })), /*#__PURE__*/React.createElement("div", {
    className: "docking-rail left"
  }, /*#__PURE__*/React.createElement("div", {
    "data-direction": "left",
    className: 'docking-direction left ' + this._getDockingState('LEFT')
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: leftHint,
    disabled: !leftHint,
    isHint: true,
    alignment: 'TOP'
  }, /*#__PURE__*/React.createElement("div", {
    className: "docking-point",
    onClick: function onClick() {
      return _this._updateDockingState('LEFT');
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "docking-line"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "docking-element center"
  }, this._generateCenterPlane()), /*#__PURE__*/React.createElement("div", {
    className: "docking-rail right"
  }, /*#__PURE__*/React.createElement("div", {
    "data-direction": "right",
    className: 'docking-direction right ' + this._getDockingState('RIGHT')
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: rightHint,
    disabled: !rightHint,
    isHint: true,
    alignment: 'TOP'
  }, /*#__PURE__*/React.createElement("div", {
    className: "docking-point",
    onClick: function onClick() {
      return _this._updateDockingState('RIGHT');
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "docking-line"
  }))), /*#__PURE__*/React.createElement("div", {
    "data-direction": "bottom",
    className: 'docking-direction bottom ' + this._getDockingState('BOTTOM')
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: bottomHint,
    disabled: !bottomHint,
    isHint: true,
    alignment: 'TOP'
  }, /*#__PURE__*/React.createElement("div", {
    className: "docking-point",
    onClick: function onClick() {
      return _this._updateDockingState('BOTTOM');
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "docking-line"
  }))));
}